export default class AddSpecOutContactsRequest {
    contactIds: string[] = [];
}
